// views/loner-note.js: BATCH B4b-1 A2, the sitting-out partner's note.
//
// When a player goes alone, the partner's hand disappears and the
// status reads "Waiting on Hugo", with nothing saying why. The partner
// gets one line in the empty hand area for the rest of the hand:
// "Hugo is going alone. You sit out this hand." Pure, no DOM.

import { lonerSeat } from '../canvas/table.js';
import { trumpBadgeStackRect } from '../canvas/trump-badge.js';
import { logPillSlot } from '../ui/log-pill-position.js';

/**
 * The note for the viewer, or null when the viewer is not sitting out a
 * live loner hand (it clears when the hand ends).
 *
 * @param {any} snap                         server game snapshot
 * @param {number|null|undefined} myLuaSeat  the viewer's lua seat (1-4)
 * @param {Record<number, string>|undefined} labels  plain seat names
 * @returns {string|null}
 */
export function sitOutNoteText(snap, myLuaSeat, labels) {
  if (!snap || myLuaSeat == null || snap.sitting_out_seat !== myLuaSeat) return null;
  const loner = lonerSeat(snap);
  if (loner == null) return null;
  return `${labels?.[loner] || `Seat ${loner}`} is going alone. You sit out this hand.`;
}

/**
 * The note's box, in canvas coordinates: the viewer's hand row, cut at
 * whatever sits beside the hand there (the You plate when it is beside
 * the hand, the timer ring, the score box, the trump badge, the log
 * pill), so the line has the full free width rather than the fan's.
 *
 * @param {import('../canvas/layout.js').TableLayout} layout
 * @param {any} snap
 * @returns {{x:number, y:number, w:number, h:number}}
 */
export function sitOutNoteRect(layout, snap) {
  const hand = layout.seats[0].handArea;
  const gap = 8;
  const cx = hand.x + Math.round(hand.w / 2);
  let left = gap;
  let right = layout.canvasW - gap;
  const obstacles = [layout.seats[0], layout.timerRing, layout.scoreboard,
    trumpBadgeStackRect(layout, snap ?? {})];
  if (layout.portrait) obstacles.push(logPillSlot(layout));
  for (const r of obstacles) {
    if (!r || r.y >= hand.y + hand.h || r.y + r.h <= hand.y) continue;
    if (r.x + r.w / 2 < cx) left = Math.max(left, r.x + r.w + gap);
    else right = Math.min(right, r.x - gap);
  }
  return { x: left, y: hand.y, w: Math.max(0, right - left), h: hand.h };
}
